jQuery(function($){
    $('.toggle-click').on('click', function() {
        var toggleItem = $('#' + $(this).data('toggle'));
        toggleItem.click();
        $('html, body').animate({
            scrollTop: toggleItem.offset().top - 100
            },'slow');
    });
});


(function($){
  $(function(){
    $( '.dynamic-list .gfield_list_cell:first-child' ).find( 'input, select, textarea' ).each(
            function() {
            if ( $( this ).val() != '' ) {
                $( this ).prop( 'readonly', true );
                $( this ).addClass('option-item');
                $( this ).attr('tabindex','-1');
                $( this ).parents('.gfield_list_group').find('.gfield_list_icons').hide();
                $( this ).parents('.gfield_list_container').find('.gfield_header_item:first-child').html('');
            }
    });

    if ($('#options-tip').length > 0) {
        var first_option = $('.options-list .gfield_list_groups');
        var options_tip = $('#options-tip');
        first_option.append(options_tip);
    }
  
    $('.show-popup').on('click', function(){
        var element = $(this).data('element');
        if(element) {
            let template = $('#' + element);
            bootbox.alert({size: 'large',backdrop: true, message: template.html(), buttons: {
                ok: {
                    className: 'd-none'
                }
            }});
            return false;
        }
    });
  });
})(jQuery); 